module.exports = __webpack_public_path__ + "ty4-f9d8a6b1.png";